export const blockedStateStyles = {
	content: {
		width: '100%',
		paddingBottom: '32px',

		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '4px',
	},

	imgCont: {
		'> img': {
			height: '312px',
			width: 'auto',
		},
	},
	link: {
		color: 'colors.rainbowBlue',
		textDecoration: 'underline',
	},
};
